import React, { useEffect, useRef, useState } from 'react';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';


function DropFileTable() {
  const selectUploadLimits = createSelector((state) => state.Upload, (state) => ({
    uploadedFiles: state.uploadedFiles
  }));
  const { uploadedFiles } = useSelector(selectUploadLimits);
  const tableRef = useRef();
  useEffect(() => {
    if (uploadedFiles !== null) {
      try {
        const table = $(tableRef.current).DataTable({
          data: uploadedFiles,
          columns: [
            {
              data: null,
              title: "Preview",
              render: (data, type, row) => {
                if (row.hasOwnProperty("preview")) {
                  return `<img class="rounded" src="${row.preview}" height="30" width="30" style="width:30px;height:30px; object-fit: contain;" />`; 
                } else {
                  return ``;
                }
              }
            },
            {
              data: "name",
              title: "Name"
            },
            {
              data: "type",
              title: "Type",
              render: (data, type, row) => {
                return `${data}`;
              }
            },
            {
              data: null,
              title: "Size",
              render: (data, type, row) => {
                if (row.hasOwnProperty("pixelSize")) {
                  return `${row.pixelSize}`
                } else {
                  return ``;
                }
              }
            },
            {
              data: "formattedSize",
              title: "Weight",
              render: (data, type, row) => {
                return `${data}`;
              }
            },
            {
              data: null,
              title: "Process",
              render: (data, type, row) => {
                return `process`;
              }
            },
            {
              data: "status",
              title: "Status",
              render: (data, type, row) => {
                if (data === 1) {
                  return `<span class="text-success">Confirmed</span>`;
                } else {
                  return `<span class="text-danger">File weight is more than the limits</span>`;
                }
              }
            }
          ],
          destroy: true,
          responsive: true,
          searching: false,
          info: false,
          paging: false,
        });

        return function () {
          table.destroy();
        };
      } catch (error) {
        // console.log(error);
      }
    }
  }, [uploadedFiles]);
  return (
    <div>
      {(uploadedFiles || []).length > 0 ?
        <div className='table-responsive table-card mt-2'>
          <table
            className="align-middle table-nowrap mb-0 table"
            style={{ width: "100%" }}
            ref={tableRef}
          >
            <thead className="table-light"></thead>
            <tbody></tbody>
          </table>
        </div>
        : null}
    </div>
  )
}

export default DropFileTable
